import { defineMessages } from 'react-intl';

/** Shared by both nav shells so the entry reads the same in either one. */
export const messages = defineMessages({
  open: {
    id: 'CLMEvolutionFeedback.open',
    defaultMessage: 'Give Feedback',
    description:
      'Label of the navigation entry that opens the CLM Evolution feedback form.',
  },
  tooltip: {
    id: 'CLMEvolutionFeedback.tooltip',
    defaultMessage: 'Tell us how this page is working for you',
    description: 'Tooltip for the CLM Evolution feedback navigation entry.',
  },
});
